export interface ILegalFormAndAccountBasis {
    _id?: string;
    name: string;
    text: { [key: string]: string };
    owner: string;
    version: number;
}
